import React, { Component } from "react";
import { connect } from "react-redux";
import { toggleGlobalLoader } from "../../../store/actions/session";
import * as actions from "../../../store/actions";
import { DateTime } from "luxon";
import _ from "lodash";
import { get as _get } from "lodash";

import * as ODCalls from "../../../store/calls/indicativeOptionData";
import { addErrorAlert } from "../../../store/calls/alertLoadingDispatch";
import { pullApplications } from "../../../store/calls";
import { withRouter } from "react-router-dom";
import formatters from "../../../utils/forms/formatters";
import AdminWrapper from "../../theme/wrappers/AdminWrapper";
import Input from "../../theme/forms/Input";
import PacefiFullScreenSpinner from "../../theme/loaders/pacefiFullScreenSpinner";
import PaginatedTable from "../../theme/tables/PaginatedTable";

class ApplicationsScreen extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            isopenFilter: false,
            filterSelected: 0,
            textFilter: 0,
            query: "",
            currentData: [],
            dateSelected: DateTime.now().toISODate(),
            dateChange: DateTime.now().toISODate(),
            dataPullLimit: 25,
            dataPullOffset: 0,
            dataSizeCount: 0,
            addressChange: '',
            filterMethod: 'address',
            isFetched: false,
            isLoading: true,

        };
    }

    componentDidMount() {
        const currentDate = this.props.location.search.split("date=")[1]
            ? this.props.location.search.split("date=")[1]
            : DateTime.now().toISODate();
        this.setState({
            dateSelected: currentDate,
            dateChange: currentDate,
            isFetched: false,
            isLoading: true,
        });
        this.fetchData(currentDate);
        toggleGlobalLoader(true);
        Promise.allSettled([
            ODCalls.getAssetTypes(),
            ODCalls.getBusinessTypes(),
            ODCalls.getAvailableImprovements(),
        ])
            .catch(() => {
                addErrorAlert("Failed to load all initial data.", 10 * 1000);
            })
            .finally(() => {
                toggleGlobalLoader(false);
            });
    }


    fetchData = () => {

        let params = {limit: this.state.dataPullLimit, offset: this.state.dataPullOffset};
        let stateUpdatePreLoad = { isFetched: false, isLoading: true };
        let stateUpdatePostLoad = { isLoading: false};
        if (this.state.filterMethod === 'date') {
            params['date'] = this.state.dateChange;
            stateUpdatePostLoad = {dateSelected: this.state.dateChange}
        } else if (this.state.filterMethod === 'address') {
            params['address'] = this.state.addressChange;
            stateUpdatePostLoad = {selectedAddress: this.state.addressChange}
        }

        this.setState(stateUpdatePreLoad);

        toggleGlobalLoader(true)
        pullApplications(params).then((res) => {
            this.setState({
                data: res.results,
                isFetched: true,
                currentData: res.results,
                dataSizeCount: res.count,
                ...stateUpdatePostLoad
            });
            toggleGlobalLoader(false)
        });
    };


    getDataForTable = () => {

        return this.state.currentData.map(d => ({
            project_name: d.project?.data.project_name,
            address: d.project?.data?.address?.formatted_address,
            modified: d.modified,
            _html_estimates_link: <a target='_blank' href={`/project-estimate/${d.project.id}`}>View Loan Estimates</a>,
            _html_application_link: <a target='_blank' href={`/application/${d.id}/`}>View App</a>
        }))
    }

    getImprovementName = (id) => {
        const { improvements } = this.props.optionData;
        if (!improvements || improvements.length == 0) return "";
        const improvement = improvements.find((i) => i.id == id);
        return improvement ? improvement.name : "";
    };


    getBusinessTypeName = (id) => {
        const { businessTypes } = this.props.optionData;
        if (!businessTypes || businessTypes.length == 0) return "";
        const businessType = businessTypes.find((i) => i.id == id);
        return businessType ? businessType.name : "";
    };


    onOpenProject = (project, estimategroup_id) => {
        this.props.setFocusedProject(project.id);

        const formFlowComputed = {
            address: project.data.address,
            programs: project.data.programs,
        };

        this.props.clearFormFlow();
        this.props.updateInputs({...project.data, id: project.id});
        this.props.updateComputed(formFlowComputed);
        this.props.updateCurrentStep(1);

        if (estimategroup_id) {
            window.location = `/share-estimate/?g=${estimategroup_id}`
        }
        this.props.history.push({
            pathname: "/project",
        });
    };


    onChangeDate = (e) => {
        this.setState({ dateChange: e.target.value, isFetched: false });
    };


    onChangeAddress = (e) => {
        this.setState({ addressChange: e.target.value, isFetched: false, dataPullOffset: 0, dataSizeCount: 0 });
    };

    onChangeFilterMethod = (e) => {
        this.setState({ filterMethod: e.target.value, isFetched: false });
    };

    handleLimitChange = (val) => {
        this.setState({dataPullLimit: val}, this.fetchData)
    }

    handleOffsetChange = (val) => {
        this.setState({dataPullOffset: val}, this.fetchData)
    }


    onSelectPastEstimateGroup = (project, id) => {
        this.onOpenProject(project, id);
    };


    renderFilter = () => {
        const { dateChange, addressChange, filterMethod } = this.state;
        return (
            <div className="field has-addons">
                <div className={'control'}>
                    <select
                        value={filterMethod}
                        onChange={this.onChangeFilterMethod}
                        className={'input'}
                        style={{width: '10em'}}
                    >
                        <option value={'date'}>Date</option>
                        <option value={'address'}>Address</option>
                    </select>
                </div>
                {filterMethod === 'date' &&
                    <div className="control">
                        <input
                            className="input"
                            style={{width: '10em'}}
                            type="date"
                            value={dateChange}
                            onChange={this.onChangeDate}
                            max={DateTime.now().toISODate()}
                            min="2021-05-01" // start of operations of PACEFI
                        />
                    </div>
                }
                {filterMethod === 'address' &&
                    <div className="control">
                        <input
                            className="input"
                            style={{width: '10em'}}
                            type="text"
                            value={addressChange}
                            onChange={this.onChangeAddress}
                            max={DateTime.now().toISODate()}
                            min="2021-05-01" // start of operations of PACEFI
                        />
                    </div>
                }
                <div className="control">
                    <button
                        className="button is-info"
                        onClick={this.fetchData}
                        // disabled={this.isFetchDisabled()}
                    >
                        Find projects
                    </button>
                </div>
            </div>
        );
    };



    isFetchDisabled = () => {
        const { isFetched, isLoading} = this.state;
        return  isLoading;
    }





    render() {
        const { currentData, isFetched, isLoading, dateSelected } = this.state;
        return (
            <AdminWrapper>
                <div className="container px-2">
                    <h1 className="is-size-4 has-text-primary mt-4  mb-4 has-text-weight-semibold  default-title ">
                        Applications
                    </h1>
                    <div className="is-flex is-justify-content-flex-end my-6">

                        {this.renderFilter()}
                    </div>
                    {currentData && currentData.length > 0 ? (
                        <PaginatedTable
                            className={'is-fullwidth is-hoverable'}
                            data={this.getDataForTable()}
                            columns={['project_name', 'address', 'modified', 'application_link', 'estimates_link']}
                            pullLimit={this.state.dataPullLimit}
                            handleLimitChange={this.handleLimitChange}
                            pullOffset={this.state.dataPullOffset}
                            handleOffsetChange={this.handleOffsetChange}
                            showSortBar={false}
                        />
                    ) : isLoading ? (
                        <p>Loading...</p>
                    ) : (
                        <p>0 Results for {this.state.filterMethod === 'date' ?
                            DateTime.fromISO(dateSelected).toFormat("DD") :
                            this.state.addressSelected
                        }</p>
                    )}


                </div>
                <PacefiFullScreenSpinner/>
            </AdminWrapper>
        );
    }
}


const mapStateToProps = (state) => ({
    optionData: state.indicativeOptionData,
    tokenData: state.user.decodedTokenData,
});



const mapDispatchToProps = (dispatch) => ({
    //focused project is alwasy ust the id
    setFocusedProject: (data) =>
        dispatch(actions.projectLeads.setFocusedProject(data)),
    updateInfoFeedDisplay: (data) =>
        dispatch(actions.infoFeed.updateInfoFeedDisplay(data)),
    clearInfoFeedDisplay: (data) =>
        dispatch(actions.infoFeed.clearInfoFeedDisplay(data)),

    updateInputs: (data) => dispatch(actions.formFlow.updateFormFlowInputs(data)),
    updateComputed: (data) =>
        dispatch(actions.formFlow.updateFormFlowComputed(data)),
    updateCurrentStep: (data) =>
        dispatch(actions.formFlow.setFormFlowCurrStep(data)),
    clearFormFlow: (data) => dispatch(actions.formFlow.clearFormFlow(data)),
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(ApplicationsScreen));
